import clsx from "classnames";
import classes from "./styles.module.scss";
import Link from 'next/link';

export default function OfficeCard({ office, className }) {
  
  const officeDetail = office.office

  return (
    <div className={clsx(className, classes.card)}>
      <img className={classes.location_image} src={officeDetail.image} alt={officeDetail.title}></img>
      <div className={classes.office_detail}>
        <div className={classes.detail_card}>
          <Link href={"/office/" + officeDetail.url_slug} passHref>
            <div className={classes.title_cont}>
              <h3 className={classes.title}>{officeDetail.location}</h3>
              <div className={classes.title_block}></div>
            </div>
          </Link>
          <div className={classes.contacts}>
            <a href={officeDetail.google_map_link} target="_blank" rel="nofollow"><img src="/icons/location_pink.png" alt="location"/>Link to Google Map</a>
            {officeDetail.email && <a><img src="/icons/envelope_pink.png" alt="email"/>{officeDetail.email}</a>}
            {officeDetail.phone && <a><img src="/icons/call_pink.png" alt="phone"/>{officeDetail.phone}</a>}
          </div>
          <div className={classes.more_info}>
            <Link href={"/office/" + officeDetail.url_slug} passHref>
              <span>More information  <img src="/icons/arrow-right.png" alt="arrow-right"></img></span>
            </Link>          
          </div>
        </div>
      </div>
    </div>
  );
}

OfficeCard.defaultProps = {
  className: "",
};
